(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    class CartDrawer extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('[role="dialog"]');

      // Use event delegation on document — safe regardless of when DOM loads
      document.addEventListener('click', (e) => {
        if (e.target.closest('[data-cart-drawer-trigger]')) {
          e.preventDefault();
          this.open();
        }
      });

      this.querySelectorAll('[data-cart-drawer-close]').forEach((el) => {
        el.addEventListener('click', () => this.close());
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.getAttribute('aria-hidden') === 'false') {
          this.close();
        }
      });
    }

    open() {
      // Measure scrollbar width BEFORE hiding overflow so page doesn't shift
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      document.documentElement.style.paddingRight = scrollbarWidth + 'px';
      document.documentElement.style.overflow = 'hidden';
      this.setAttribute('aria-hidden', 'false');
      const first = this.panel.querySelector('a[href], button:not([disabled])');
      if (first) first.focus();
    }

    close() {
      this.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      document.documentElement.style.paddingRight = '';
    }
  }

  customElements.define('cart-drawer', CartDrawer);
  } catch(e) { console.error(e); }
})();

})();
